export default (params) => ({
  trigger: {
    name: 'quantity_selector.change_quantity',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
      type: {
        enum: [
          'add',
          'remove',
        ],
      },
      quantity: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'order_block',
          'bottom_product_card',
          'shopping_cart',
        ],
      },
    },
    event: {
      name: 'change_quantity',
    },
  },
});
